const PREFIX = 'home-special-offer';

export const SPARTAN_HOME_SPECIAL_OFFER_TRACKING = {
  section: PREFIX,
  itemList: `${PREFIX}-item-list`,
  item: (index: number) => `${PREFIX}-item-${index + 1}`,
  itemHeader: (index: number) => `${PREFIX}-item-${index + 1}-header`,
  itemLogo: (index: number) => `${PREFIX}-item-${index + 1}-logo`,
  itemLogoDesktop: (index: number) =>
    `${PREFIX}-item-${index + 1}-logo-desktop`,
  itemImage: (index: number) => `${PREFIX}-item-${index + 1}-image`,
  itemCta: (index: number) => `${PREFIX}-item-${index + 1}-button-group`,
  itemButton: (index: number) => `${PREFIX}-item-${index + 1}-button`,
  pagination: `${PREFIX}-pagination`,
  paginationItem: `${PREFIX}-pagination-item`,
} as const;

export const SPARTAN_HOME_SPECIAL_OFFER_DATA_GA = {
  section: PREFIX,
} as const;
